import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
import { painCosts } from '../data/includes';
export function PainPoints() {
  return <section className="py-24 px-4 bg-cream" data-id="element-173" data-mp="2lp556r9nb2to">
      <div className="max-w-3xl mx-auto" data-id="element-174" data-mp="26z7kwmeu6x9r">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="text-center mb-12" data-id="element-175" data-mp="26wbqh8276qq2">
          <p className="text-terracotta font-semibold tracking-[0.18em] uppercase text-xs mb-3" data-id="element-176" data-mp="1o1el3szif3gl">
            A Sunday Night That Feels Too Familiar
          </p>
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6 text-charcoal" data-id="element-177" data-mp="3idbhm0ct6zii">
            Does this sound familiar?
          </h2>
          <div className="text-lg text-charcoal-soft leading-relaxed bg-paper p-6 rounded-2xl border border-warmgray text-left space-y-4" data-id="element-178" data-mp="3nbwfvu8i394b">
            <p data-id="element-179" data-mp="1u1u2f49st2m5">
              Sunday evening. 10 PM. You have an art class tomorrow morning.
            </p>
            <p data-id="element-180" data-mp="27tidd48b9l1j">
              And you're still there—searching for activities that work, trying
              to build a progression that actually flows, looking for visual
              references, choosing materials, and wondering if your lesson plan
              makes sense for this group's level.
            </p>
            <p data-id="element-181" data-mp="1b3rdeph935oc">
              <span className="text-terracotta font-medium" data-id="element-182" data-mp="1b4anxl4kmrsc">
                Not because you don't know art.
              </span>{' '}
              You already know art. Because no one ever gave you a complete,
              ready-to-teach library. You've been building every single class
              from scratch.
            </p>
            <p data-id="element-183" data-mp="2vil1muxgac50">
              The time you should be resting, you're planning—and you walk into
              class wishing you'd prepared more.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="space-y-6" data-id="element-184" data-mp="1t7htgo2fbcal">
          <h3 className="text-xl font-bold text-charcoal mb-8 text-center" data-id="element-185" data-mp="1ackkz04fv8ww">
            The Real Cost of Not Having the Right Resource
          </h3>

          <ul className="space-y-3" data-id="element-186" data-mp="1jf3lhdkr59fz">
            {painCosts.map((point, i) => <motion.li key={point} initial={{
            opacity: 0,
            x: -16
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.25,
            delay: Math.min(i, 5) * 0.04,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex items-start gap-4 bg-sand p-4 rounded-xl border border-warmgray" data-id="element-187" data-mp="1o5sfazjwmiia" data-mpi={i}>
                <X size={18} className="text-terracotta-dark shrink-0 mt-0.5" aria-hidden="true" data-id="element-188" data-mp="a5fi0b1ntyfa" />
                <span className="text-charcoal-soft" data-id="element-189" data-mp="gxmo9c5gjj1">{point}</span>
              </motion.li>)}
          </ul>

          <div className="text-center mt-12 pt-8 border-t border-warmgray" data-id="element-190" data-mp="3rm761i5n1zjo">
            <p className="text-2xl font-serif font-bold text-terracotta-deep" data-id="element-191" data-mp="3mo5lesskds63">
              Stop giving away your preparation time. Your dedication is already
              there. What you need now is the right tool.
            </p>
            <p className="text-xl mt-4 text-charcoal" data-id="element-192" data-mp="3do8sug32095r">
              Plan an entire year of art classes today.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}